import { Link } from 'gatsby';
import React from 'react';

export const home_faqs = [
  {
    title: 'What makes you better than a traditional letting agent?',
    body: (
      <>
        <div>
          We found that traditional letting agents can be hard to get hold of,
          impersonal and generally not that great to work with. Whether you are
          trying to find your next home or trying to let yours out, your typical
          letting agent can slow things down. We want to fix this outdated
          process for both landlords AND tenants. Our tech speeds the process up
          and makes it more transparent to all parties!
        </div>
        <br />
        <div>
          We aim to be as transparent, efficient and effective when it comes to
          letting property.
        </div>
      </>
    ),
  },
  {
    title:
      'My current letting agent is hard to get in touch with, how will Oasis Living be any better at communication?',
    body: (
      <>
        <div>
          We have a dedicated customer care team as well as a qualified and
          capable operations team that are waiting to ensure your calls and
          emails get answered as soon as possible. We know that letting property
          can be stressful and your letting agent should alleviate that stress,
          not add to it!!
        </div>
        <br />
        <div>
          See how{' '}
          <Link to="/tenant/">we are helping tenants as well as landlords</Link>
          .
        </div>
      </>
    ),
  },
  {
    title:
      "I don't like using too much technology, can I still use Oasis Living?",
    body: (
      <>
        <div>
          Absolutely not! All of our technological solutions are agent side,
          meaning that all you need to do is contact us, create an account and
          we&apos;ll get you up and running. Checking the lettings dashboard
          couldn&apos;t be easier. Much like checking a bank balance, all of the
          details will be displayed on-screen for you to see easily. If you have
          issues, you can easily contact us within the dash or by phone.
        </div>
        <br />
        <div>
          We know not everyone gets along well with new tech solutions but that
          doesn&apos;t mean they can&apos;t enjoy{' '}
          <Link to="/about-us/">a simple and transparent letting service!</Link>
        </div>
      </>
    ),
  },
  {
    title:
      "I'm a landlord, how will you make sure I only get the best quality tenants?",
    body: (
      <>
        <div>
          When letting with Oasis Living, your property will be listed on all of
          the major property marketing websites like Rightmove and Zoopla.
          We&apos;ll take care of the referencing and viewing, making sure to
          assess the quality of the tenant at all times. Once they are on the
          platform, we tenants can earn points for paying rent on time, allowing
          us to track which tenants always pay up and which ones need to brush
          up!{' '}
        </div>
        <br />
        <div>
          Find out more about how we&apos;ll find you the perfect tenants.
        </div>
      </>
    ),
  },
  {
    title: 'What are your fees?',
    body: (
      <>
        <div>
          Our fees are much lower than the traditional letting agent that you
          are used to. We only charge 15% for a fully let and managed service.
          We will also reduce this fee each year starting from year 1!
        </div>
        <br />
        <div>
          We also only take 10% for letting services, covering property
          marketing, viewings, referencing and more. Our services are faster and
          more effective too, so you don&apos;t need to worry about losing money
          while you wait for your property to fill up with tenants!
        </div>
        <br />
        <div>
          Finally we offer a management fee of 5%. We work with a great network
          of certified tradespeople that can fix any issue FAST. Tenants can
          raise issues through the Oasis Living platform and ensure and we will
          automatically inform the right person for the job!
        </div>
        <br />
        <div>
          Find out more about our pricing by visiting our{' '}
          <Link to="/pricing">pricing page</Link>.
        </div>
      </>
    ),
  },
  {
    title:
      'Sometimes I need a tenant for only a couple of months, can you help with mid-lets?',
    body: (
      <>
        <div>
          Funny you should ask! Oasis Living started out as a mid-lets
          specialist and we are still offering high quality services to a lot of
          our landlords!
        </div>
        <br />
        <div>
          Whether you are looking to fill a 2 month void before you new long-let
          starts or you want to increase your yield with a mid-let model,
          we&apos;ve got you covered!
        </div>
        <br />
        <div>
          <a href="https://stays.oasis-living.com/" target="_blank">
            Check out our mid-lets page for more information
          </a>
        </div>
      </>
    ),
  },
];
